<!--AFFICHAGE BLOC DIRIGEANTS -->
<template>
  <v-col md="12" class="pa-3 d-flex flex-column" v-if="this.condition()" >
                      <a class="anchor" id="blocdirigeants"></a>

    <v-card elevation="2">
      <v-card-title>
        <v-icon dense left color="indigo darken-2"> person </v-icon> Dirigeants</v-card-title
      >
      <v-card-text>
        <v-data-table
            v-if="this.dirigeants!=null"
          dense
          :headers="headers"
          :items="dirigeants"
          item-key="adId"
          class="elevation-1"
        >
          <template
            v-for="header in headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
            v-slot:[`item.${header.value}`]="{ header, value }"
          >
            {{ header.formatter(value) }}
          </template>
            <template #item.siren_executive="{ item }"><a @click="displaySelected(item.siren_executive)">
                      <v-icon x-small v-if="item.siren_executive!=''">mdi-open-in-new</v-icon>
                      {{ item.siren_executive ? item.siren_executive : "" }}</a></template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "Dirigeants",
  props: ["etablissement"],
  components: {},
  computed: {
    dirigeants: function () {
      var dirigeants =  this.$store.getters.getbloc("contact", "donnees","executive",null,"valeur")
        if (dirigeants==null) {
          dirigeants = this.$store.getters.getbloc("contact", "donnees", "dirigeantsInpi", null, "valeur")
        }
      return dirigeants;
    },
    headers() {
      return [
        { text: "Status", value: "statut_executive", align: "start" },
        { text: "Civ", value: "civilite_executive", align: "start" },
        { text: "Nom", value: "name_executive", align: "start" },
        { text: "Prenom", value: "firstname_executive", align: "start" },
        { text: "Siren", value: "siren_executive", align: "start" },
        {
          text: "Date de naissance",
          value: "birthday_executive",
          align: "start",
          formatter: this.formatDate,
        },
        {
          text: "Adresse",
          value: "adresse_executive",
          align: "start",
          formatter: this.formatAdrese,
        },
        {
          text: "Nationalité",
          value: "nationality_executive:null",
          align: "start",
        },
      ];
    },
  },

  methods: {
     displaySelected(siret) {
        this.$store.dispatch('getEtablissement',siret)
    },
    condition() {
      return this.$store.getters.condition("contact", "donnees","executive", "valeur" ) ||
         this.$store.getters.condition("contact", "donnees","dirigeantsInpi", "valeur" ) ;
    },
    formatDate(value) {
      if (value && value.length>8) {
        return new Date(Date.parse(value)).toLocaleDateString();
      } else {
        return value;
      }
    },
    formatAdrese(value) {
      if (value) {
        return (
          value.street +
          (value.street2 != null ? "\n" + value.street2 : "") +
          "\n" +
          value.postalCode +
          " " +
          value.locality +
          "\n" +
          (value.country != null ? value.country : "")
        );
      } else {
        return "";
      }
    },
  },
};
</script>
